// Rotate and flip, kept as a small state while the user clicks, and turned
// into pixels once, at upload (renderEditedImage). Every combination of
// quarter turns and flips is one of eight: a mirror (left-right, applied to
// the original first) followed by a rotation. Keeping that normal form means
// clicks that cancel out (four turns, two flips, flip + flip = half turn)
// leave nothing to render.

export const NO_EDIT = Object.freeze({ rotation: 0, mirror: false });

const turn = degrees => ((degrees % 360) + 360) % 360;

/**
 * Applies one button press, as the user sees the image on screen.
 *
 * @param {{rotation: number, mirror: boolean}} edit
 * @param {"rotateRight"|"rotateLeft"|"flipHorizontal"|"flipVertical"} action
 */
export function applyEdit(edit, action) {
  const { rotation, mirror } = edit;
  switch (action) {
    case "rotateRight":
      return { rotation: turn(rotation + 90), mirror };
    case "rotateLeft":
      return { rotation: turn(rotation - 90), mirror };
    // Mirroring what is on screen reverses the turn already made.
    case "flipHorizontal":
      return { rotation: turn(-rotation), mirror: !mirror };
    // Upside-down mirror = left-right mirror plus a half turn.
    case "flipVertical":
      return { rotation: turn(180 - rotation), mirror: !mirror };
    default:
      return edit;
  }
}

export function isEdited(edit) {
  return !!edit && (edit.rotation !== 0 || edit.mirror);
}

/** CSS for the preview; right to left, like the pixels: mirror, then turn. */
export function editTransform(edit) {
  if (!isEdited(edit)) return "none";
  return `rotate(${edit.rotation}deg)${edit.mirror ? " scaleX(-1)" : ""}`;
}

/** The size of the result: a quarter turn swaps width and height. */
export function editedSize(width, height, edit) {
  const quarter = edit.rotation === 90 || edit.rotation === 270;
  return quarter ? { width: height, height: width } : { width, height };
}
